{
    module.exports.CLOUDFRONT_URL = "https://d3hp2fydbm1gg5.cloudfront.net/";
    module.exports.BUCKET_URL = 'https://somadha.s3.amazonaws.com/';
    module.exports.S3_PREASSIGNED_POST_URL = 'https://laojnj5jr5.execute-api.ap-south-1.amazonaws.com/dev/s3-presigned-post';
}


